import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useDeleteSubIndustry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/subindustry/delete/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["viewSubIndustry"] });
      queryClient.invalidateQueries({ queryKey: ["allSubIndustries"] });
      queryClient.invalidateQueries({ queryKey: ["subIndustriesList"] });
    },
  });
};
